import { CiType } from './ci-type';

export class AnalysisToolTip {
    text?: string;
    testCode?: string;
    comment?: string;
    localisedName?: string;
    instruction?: string;
    description?: string;
    applicableOn?: string;
    method?: string;
    objective?: string;
    memberTests?: any;
    additionalColumn9?: string;
    packageCode?: string;
    name?: string;
    parameters?: any;
    comlimsCode?: string;
    tests?: any;
    ciItems?: any;
    code?: string;
    ciType: CiType;
}
